(function () {
  "use strict";

  function initMarquee(track) {
    var duration = parseFloat(track.getAttribute("data-duration")) || 12;
    var direction = track.getAttribute("data-direction") === "reverse" ? -1 : 1;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Track markup is the content duplicated once, so scrollWidth/2 is exactly
    // one seamless loop distance (same assumption the old CSS translateX(-50%) used).
    // Safe to measure immediately: every .brands-marquee-item has a fixed
    // width set inline via Liquid, so this number doesn't change once images load.
    var halfWidth = track.scrollWidth / 2;
    if (!halfWidth) return;

    var pxPerSecond = halfWidth / duration;
    var position = 0;
    var lastTime = null;
    var paused = reduceMotion;

    // Disable the CSS @keyframes animation immediately — JS owns the
    // transform from this point on, starting at 0, not wherever a CSS
    // animation cycle happened to be.
    track.classList.add("js-marquee-active");
    track.style.transform = "translate3d(0px, 0, 0)";

    function step(timestamp) {
      if (lastTime === null) lastTime = timestamp;
      var delta = (timestamp - lastTime) / 1000;
      // Guard against a huge delta after a background tab / dropped frames,
      // which would otherwise cause a visible jump.
      if (delta > 0.25) delta = 0.25;
      lastTime = timestamp;

      if (!paused) {
        position -= direction * pxPerSecond * delta;

        if (direction === 1) {
          if (position <= -halfWidth) position += halfWidth;
        } else {
          if (position >= 0) position -= halfWidth;
        }

        track.style.transform = "translate3d(" + position + "px, 0, 0)";
      }

      requestAnimationFrame(step);
    }

    // Keep pace with genuine viewport/layout resizes only — this does not
    // run on page load, so it never causes an initial jump.
    if (typeof ResizeObserver !== "undefined") {
      var resizeObserver = new ResizeObserver(function () {
        var newHalf = track.scrollWidth / 2;
        if (newHalf > 0) {
          halfWidth = newHalf;
          pxPerSecond = halfWidth / duration;
        }
      });
      resizeObserver.observe(track);
    }

    // Pause while scrolled out of view: saves cycles and avoids a big
    // "catch-up" jump when it re-enters (lastTime resets cleanly instead).
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            paused = !entry.isIntersecting || reduceMotion;
            if (entry.isIntersecting) lastTime = null;
          });
        },
        { threshold: 0 }
      );
      io.observe(track);
    }

    requestAnimationFrame(step);
  }

  function init() {
    var tracks = document.querySelectorAll(".brands-marquee-track[data-js-marquee]");
    tracks.forEach(initMarquee);
  }

  // Run as soon as the DOM exists — do NOT wait for window 'load' (that
  // waits for every image to finish downloading, which left the CSS
  // animation running alone, visibly, until JS finally took over).
  // This is safe because every .brands-marquee-item has a fixed width set
  // inline by Liquid (item_width / box_width), so the track's total width
  // never depends on images finishing — it's correct the instant the
  // elements exist, before any image has loaded.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();